import { useEffect, useState } from 'react'

import { partnersWidgetInViewport } from '@cred/react-analytics/events'

import { fireGtmEvent } from 'utils/gtm'

const useViewportAnalytics = ({ ref, contexts = [], trackSnowplowEvent }) => {
  const [isIntersecting, setIntersecting] = useState(false)
  const [seen, setSeen] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting)
    })

    try {
      observer.observe(ref.current)
    } catch (err) {
      console.error(err)
    }

    return () => {
      observer.disconnect()
    }
  }, [ref])

  useEffect(() => {
    if (!seen && isIntersecting) {
      setSeen(true)

      trackSnowplowEvent(partnersWidgetInViewport, {})
      fireGtmEvent('partnerWidgetInViewport', contexts)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIntersecting, seen])

  return isIntersecting
}

export default useViewportAnalytics
